import type { ReactNode } from "react";
import type { CheckboxProps as AriaCheckboxProperties } from "react-aria-components";
import { Checkbox as AriaCheckbox } from "react-aria-components";

import { IcCheckbox } from "@jetblue/kit-icons/ic-checkbox";
import { cn } from "../../utilities/tailwind";

export type InputCheckboxProperties = Omit<
  AriaCheckboxProperties,
  "className" | "children" | "slot" | "style"
> & {
  /**
   * Class name to apply to the <label /> that wraps the checkbox
   */
  className?: string;

  /**
   * Content displayed along side the checkbox
   */
  children: ReactNode;
};
export const InputCheckbox = ({
  children,
  className = "",
  ...properties
}: InputCheckboxProperties) => (
  <AriaCheckbox
    className={cn(
      "group cursor-pointer items-center text-on-surface data-disabled:cursor-default",
      className,
    )}
    {...properties}
  >
    <span className="flex w-fit items-center group-data-focus-visible:outline group-data-focus-visible:outline-offset-[3px] group-data-focus-visible:outline-primary">
      <span className="me-2 box-content inline-flex size-4 items-center justify-center border border-primary text-transparent transition-all *:scale-0 group-data-disabled:border-disabled-variant group-data-[selected=true]:bg-primary group-data-[selected=true]:text-on-primary group-data-[selected=true]:*:scale-100 group-data-[selected=true]:group-data-disabled:bg-disabled-variant">
        <IcCheckbox className="inline" />
      </span>
      <span className="group-data-disabled:text-disabled-variant">
        {children}
      </span>
    </span>
  </AriaCheckbox>
);
InputCheckbox.displayName = "InputCheckbox";
